import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Inicial from "./pages/Inicial";
import Detalhes from "./pages/Detalhes";
import Menu from "./components/Menu";
import Pesquisa from "./components/Pesquisa/Pesquisa";
import Pesquisado from "./components/Pesquisado/Pesquisado";
import Rodape from "./components/Rodape/Rodape";
import RV from "./pages/RV";
import RA from "./pages/RA";
import Video360i from "./pages/V360i";
import Video360 from "./pages/V360";
import TrilhaNavegacao from "./components/TrilhaNavegacao/TrilhaNavegacao";
import Login from "./components/Login";
import Admin from "./pages/Admin";
import AdminForm from "./pages/AdminForm";
import AdminUserForm from "./pages/AdminUserForm";
import AdminReports from "./pages/AdminReports";
import { useAuth } from "./context/AuthContext";
import { useProjetosComBanco } from "./hooks/useProjetosComBanco";
import { projetoCorrespondeBusca } from "./utils/projetos";
import "./styles.css"

function App() {
  const [textoPesquisa, setTextoPesquisa] = useState("");
  const [resultados, setResultados] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const todosProjetos = useProjetosComBanco();



  function aplicarPesquisa(texto) {
    const textoLimpo = texto.trim();
    setTextoPesquisa(textoLimpo);

    if (textoLimpo === "") {
      navigate("/", { replace: true });
      return;
    }

    navigate("/?q=" + encodeURIComponent(textoLimpo), { replace: true });
  }

  /* Limpa pesquisa e retorna ao estado inicial */
  function limparPesquisa() {
    setTextoPesquisa("");
    setResultados([]);
    navigate("/", { replace: true });
  }

  function irParaCategoria(rota) {
    setTextoPesquisa("");
    setResultados([]);
    navigate(rota);
  }


  /* ========================= TrilhaNavegacao ========================= */

  /* ðŸ”¹ Detecta rota atual */
  const caminhoAtual = location.pathname;

  /* ðŸ”¹ Verifica se estÃ¡ na Home */
  const estaNaHome = caminhoAtual === "/";

  useEffect(() => {
    if (!estaNaHome) return;

    const textoLimpo = new URLSearchParams(location.search).get("q") || "";
    const termo = textoLimpo.trim();

    setTextoPesquisa(termo);

    if (!termo) {
      setResultados([]);
      return;
    }

    setResultados(
      todosProjetos.filter((projeto) =>
        projetoCorrespondeBusca(projeto, termo)
      )
    );
  }, [estaNaHome, location.search, todosProjetos]);
  /* ðŸ”¹ Busca sÃ³ existe na Home */
  const possuiQueryBusca =
    estaNaHome && location.search.includes("?q=");

  /* ðŸ”¹ PÃ¡gina de detalhes */
  const estaNosDetalhes = caminhoAtual.startsWith("/projeto");

  /* ðŸ”¹ Categorias */
  const rotasCategorias = ["/rv", "/ra", "/video360", "/video360i"];

  const estaEmCategoria = rotasCategorias.some(function (rota) {
    return caminhoAtual.startsWith(rota);
  });

  /* ðŸ”¹ Regra final da trilha */
  const mostrarTrilha =
    estaNosDetalhes ||
    possuiQueryBusca ||
    estaEmCategoria;

  // Verifica as rotas especiais (login/admin) para esconder menu/busca
  const estaNoLogin = caminhoAtual === "/login";
  const estaNoAdmin = caminhoAtual.startsWith("/admin");
  const rotasEspeciais = estaNoLogin || estaNoAdmin;

  return (
    <>

      {/* ðŸ” ELEMENTOS FIXOS */}
      {!rotasEspeciais && (
        <>
          <Menu
            texto={textoPesquisa}
            onTextoChange={setTextoPesquisa}
            onPesquisar={aplicarPesquisa}
            aoIrHome={limparPesquisa}
          />

          <div className="busca-global">
        <div className="container">
          <div
            className={
              mostrarTrilha
                ? "busca-container dupla"
                : "busca-container centralizada"
            }
          >
            {mostrarTrilha ? (
              <div className="area-trilha">
                <TrilhaNavegacao
                  aoIrHome={limparPesquisa}
                  aoIrCategoria={irParaCategoria}
                />
              </div>
            ) : null}

            <Pesquisa
              texto={textoPesquisa}
              onTextoChange={setTextoPesquisa}
              onPesquisar={aplicarPesquisa}
            />
          </div>
        </div>
      </div>

      <div className="conteudo-principal container">
        {/* ðŸ”€ ROTAS */}
        <Routes>
          <Route
            path="/"
            element={
              possuiQueryBusca ? (
                <Pesquisado
                  resultados={resultados}
                  limpar={limparPesquisa}
                />
              ) : (
                <Inicial />
              )
            }
          />

          <Route path="/projeto/:id" element={<Detalhes />} />
          <Route path="/rv" element={<RV />} />
          <Route path="/ra" element={<RA />} />
          <Route path="/video360" element={<Video360 />} />
          <Route path="/video360i" element={<Video360i />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin"
            element={<ProtectedRoute><Admin /></ProtectedRoute>}
          />
          <Route path="/admin/novo" element={<ProtectedRoute><AdminForm /></ProtectedRoute>} />
          <Route path="/admin/editar/:id" element={<ProtectedRoute><AdminForm /></ProtectedRoute>} />
          <Route path="/admin/usuarios/novo" element={<ProtectedRoute><AdminUserForm /></ProtectedRoute>} />
          <Route path="/admin/relatorios" element={<ProtectedRoute><AdminReports /></ProtectedRoute>} />
        </Routes>
      </div>
          <Rodape />
        </>
      )}

      {/* rota login e admin */}
      {rotasEspeciais && (
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin"
            element={<ProtectedRoute><Admin /></ProtectedRoute>}
          />
          <Route path="/admin/novo" element={<ProtectedRoute><AdminForm /></ProtectedRoute>} />
          <Route path="/admin/editar/:id" element={<ProtectedRoute><AdminForm /></ProtectedRoute>} />
          <Route path="/admin/usuarios/novo" element={<ProtectedRoute><AdminUserForm /></ProtectedRoute>} />
          <Route path="/admin/relatorios" element={<ProtectedRoute><AdminReports /></ProtectedRoute>} />
        </Routes>
      )}





    </>
  );
}

/* ðŸ” Rota Protegida - redireciona para login se nÃ£o estiver autenticado */
function ProtectedRoute({ children }) {
  const { isLoggedIn } = useAuth();
  return isLoggedIn ? children : <Navigate to="/login" replace />;
}

export default App;

